import axios from 'axios';

import config from '@/config/config';
import { headers } from './auth.headers';
import { formatQueryString } from '@/helpers/query-string';
import { IProductType } from '@/domain/product-type.model';
import { IPaginateVueTable } from '@/interfaces/IPaginateVueTable';

const url_api_base = config.url_api_base;

export const insert = (data: IProductType): Promise<IProductType> => {
  return axios.post(`${url_api_base}/product-type`, data, headers());
};

export const update = (data: IProductType): Promise<IProductType> => {
  return axios.patch(`${url_api_base}/product-type/${data.id}`, data, headers());
};

export const get = (id: string): Promise<IProductType> => {
  const url = `${url_api_base}/product-type/${id}`;

  return axios.get(url, headers()).then((res) => res?.data);
};

export const list = (
  offset?: number,
  limit?: number,
  order?: string,
  sort?: string,
  filter?: string,
): Promise<IPaginateVueTable<IProductType>> => {
  const query = formatQueryString(offset, limit, order, sort, filter);
  const url = `${url_api_base}/product-type${query}`;

  return axios.get(url, headers()).then((res) => res?.data);
};

export const listActive = (): Promise<IProductType[]> => {
  const url = `${url_api_base}/product-type/list-active`;

  return axios.get(url, headers()).then((res) => res?.data);
};
